import { useMemo } from "react";
import { resolveMediaResourceAvailability } from "./media-resource-state-utils";
import { useRoomResourceAvailability } from "./useRoomResourceAvailability";

export function useLocalMediaResourceAvailability(resourceId, { label, locallyOwned = false, fallbackReason = null }) {
  const { roomResourceState } = useRoomResourceAvailability(resourceId, { locallyActive: locallyOwned });

  return useMemo(
    () =>
      resolveMediaResourceAvailability({
        roomResourceState,
        resourceId,
        label,
        locallyOwned,
        fallbackReason
      }),
    [roomResourceState, resourceId, label, locallyOwned, fallbackReason]
  );
}
